import { render } from "./Comentarios_sap.vue?vue&type=template&id=c19c6a06&bindings={\"breadcrumbA\":\"data\",\"breadcrumbB\":\"data\",\"descripcion\":\"data\",\"triggers\":\"data\",\"personal\":\"data\",\"asignarValor\":\"options\",\"asignarSector\":\"options\",\"obtenerPersonal\":\"options\",\"refrescarPersonal\":\"options\"}"
import script from "./Comentarios_sap.vue?vue&type=script&lang=js"
export * from "./Comentarios_sap.vue?vue&type=script&lang=js"
script.render = render

export default script